import React, { useState, useEffect } from 'react';
import './BookRecord.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';
function BookRecord() {
    const [showBookRecord, setShowBookRecord] = useState(true);
    const [sortTitles, setSortTitles] = useState('');
    const [sortPublisher, setSortPublisher] = useState('');
    const [sortClassName, setSortClassName] = useState('');
    const [sortAuthor, setSortAuthor] = useState('');
    const [sortClassNo, setSortClassNo] = useState('');
    const [sortBookCode, setSortBookCode] = useState('');
    const [entriesToShowRecord, setEntriesToShowRecord] = useState(10);
    const [searchQueryRecord, setSearchQueryRecord] = useState('');
    const [bookRecords, setBookRecords] = useState([]);
    const [loadingBookRecords, setLoadingBookRecords] = useState(false);
    const [errorBookRecords, setErrorBookRecords] = useState(null);

    useEffect(() => {
        const fetchBookRecords = async () => {
            setLoadingBookRecords(true);
            setErrorBookRecords(null);
            try {
                const response = await fetch(Constants.API_PATH +'/book_records'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error('Failed to fetch book records');
                }
                const data = await response.json();
                setBookRecords(data);
            } catch (error) {
                setErrorBookRecords(error.message);
            } finally {
                setLoadingBookRecords(false);
            }
        };

        fetchBookRecords();
    }, []);

    const handleSortTitlesChange = (e) => {
        setSortTitles(e.target.value);
    };

    const handleSortPublisherChange = (e) => {
        setSortPublisher(e.target.value);
    };

    const handleSortClassNameChange = (e) => {
        setSortClassName(e.target.value);
    };

    const handleSortAuthorChange = (e) => {
        setSortAuthor(e.target.value);
    };

    const handleSortClassNoChange = (e) => {
        setSortClassNo(e.target.value);
    };

    const handleSortBookCodeChange = (e) => {
        setSortBookCode(e.target.value);
    };

    const handleSearchBookRecord = () => {
        // Logic to filter book records based on the sort fields and search query
        console.log('Searching book records with:', {
            sortTitles,
            sortPublisher,
            sortClassName,
            sortAuthor,
            sortClassNo,
            sortBookCode,
            searchQueryRecord,
        });
    };

    const handleEntriesChangeRecord = (e) => {
        setEntriesToShowRecord(e.target.value);
    };

    const handleSearchChangeRecord = (e) => {
        setSearchQueryRecord(e.target.value);
    };

    const handleExportBookList = () => {
        // Logic to export the book list
        console.log('Exporting book list...');
    };

    return (
        showBookRecord && (
            <div className="book-record-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Book Record</span>
                </nav> */}
                <h2 className="section-title">Book Record</h2>
                <div className="search-filters">
                    <div className="filter-group">
                        <label htmlFor="sortTitles" className="filter-label">Sort Titles</label>
                        <input
                            type="text"
                            id="sortTitles"
                            className="filter-input"
                            placeholder="search titles"
                            value={sortTitles}
                            onChange={handleSortTitlesChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="sortPublisher" className="filter-label">Sort Publisher</label>
                        <input
                            type="text"
                            id="sortPublisher"
                            className="filter-input"
                            placeholder="search Publisher"
                            value={sortPublisher}
                            onChange={handleSortPublisherChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="sortClassName" className="filter-label">Sort Class Name</label>
                        <input
                            type="text"
                            id="sortClassName"
                            className="filter-input"
                            placeholder="search Class Name"
                            value={sortClassName}
                            onChange={handleSortClassNameChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="sortAuthor" className="filter-label">Sort Author</label>
                        <input
                            type="text"
                            id="sortAuthor"
                            className="filter-input"
                            placeholder="search Author"
                            value={sortAuthor}
                            onChange={handleSortAuthorChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="sortClassNo" className="filter-label">Sort Class No</label>
                        <input
                            type="text"
                            id="sortClassNo"
                            className="filter-input"
                            placeholder="search Class No"
                            value={sortClassNo}
                            onChange={handleSortClassNoChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="sortBookCode" className="filter-label">Sort Book Code</label>
                        <input
                            type="text"
                            id="sortBookCode"
                            className="filter-input"
                            placeholder="search Book Code"
                            value={sortBookCode}
                            onChange={handleSortBookCodeChange}
                        />
                    </div>
                    <button className="search-button" onClick={handleSearchBookRecord}>Search</button>
                </div>
                <div className="table-filters">
                    <div className="entries">
                        Show
                        <SearchableSelect
                            value={entriesToShowRecord}
                            onChange={handleEntriesChangeRecord}
                            options={[
                                { value: '10', label: '10' },
                                { value: '25', label: '25' },
                                { value: '50', label: '50' },
                                { value: '100', label: '100' }
                            ]}
                            className="entries-select"
                            clearable={false}
                        />
                        entries
                    </div>
                    <div className="search">
                        Search:
                        <input
                            type="text"
                            className="search-input"
                            value={searchQueryRecord}
                            onChange={handleSearchChangeRecord}
                            placeholder="Search..."
                        />
                    </div>
                </div>
                <div className="table-responsive">
                    {loadingBookRecords ? (
                        <p>Loading Book Records...</p>
                    ) : errorBookRecords ? (
                        <p>{errorBookRecords}</p>
                    ) : (
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Name</th>
                                    <th>Book Code</th>
                                    <th>Copies</th>
                                    <th>Author</th>
                                    <th>Publisher</th>
                                    <th>Book Pages</th>
                                    <th>Edition</th>
                                    <th>Class No</th>
                                    <th>Class Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookRecords.length === 0 ? (
                                    <tr>
                                        <td colSpan="10">No data available in table</td>
                                    </tr>
                                ) : (
                                    bookRecords.map((record, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{record.name}</td>
                                            <td>{record.bookCode}</td>
                                            <td>{record.copies}</td>
                                            <td>{record.author}</td>
                                            <td>{record.publisher}</td>
                                            <td>{record.bookPages}</td>
                                            <td>{record.edition}</td>
                                            <td>{record.classNo}</td>
                                            <td>{record.className}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="pagination">
                    <button disabled>Previous</button>
                    <button>Next</button>
                </div>
                <button className="export-button" onClick={handleExportBookList}>Export Book List</button>
            </div>
        )
    );
}

export default BookRecord;